// extracted by mini-css-extract-plugin
module.exports = {"player":"AudioPlayer_player__35GDn","west":"AudioPlayer_west__2Yeic","east":"AudioPlayer_east__3Smxq","background":"AudioPlayer_background__1cmSr"};